import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=2ec132e8&scoped=true"
import script from "./VendorDetails.vue?vue&type=script&lang=js"
export * from "./VendorDetails.vue?vue&type=script&lang=js"
import style0 from "./VendorDetails.vue?vue&type=style&index=0&id=2ec132e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec132e8",
  null
  
)

export default component.exports